import { render, staticRenderFns } from "./NewsWrapper.vue?vue&type=template&id=17d5f4b6&scoped=true"
import script from "./NewsWrapper.vue?vue&type=script&lang=js"
export * from "./NewsWrapper.vue?vue&type=script&lang=js"
import style0 from "./NewsWrapper.vue?vue&type=style&index=0&id=17d5f4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d5f4b6",
  null
  
)

export default component.exports